import { useState, useCallback } from 'react';
import dayjs from 'dayjs';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { loadSalesOrderList } from '../services/OrderManagement';

export const useFetchSalesOrders = () => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchOrders = useCallback(
        async ({ FromMODate, ToMODate, FinancierYear, showError }) => {
            if (!FromMODate) {
                showError('Please select the from date', 'warning');
                return;
            }
            if (!ToMODate) {
                showError('Please select the to date', 'warning');
                return;
            }

            try {
                const formattedFromMODate = dayjs(FromMODate).format('DD-MMM-YYYY');
                const formattedToMODate = dayjs(ToMODate).format('DD-MMM-YYYY');

                const orderData = {
                    FromMODate: formattedFromMODate,
                    ToMODate: formattedToMODate,
                    FinancierYear,
                    CompanyID: localStorage.companyid,
                    username: localStorage.userID,
                };

                setLoading(true);

                const data = await loadSalesOrderList(orderData);
                if (data && data.length > 0) {
                    const formattedData = data.map((row, index) => ({
                        ...row,
                        id: index + 1,
                    }));

                    setTableData(formattedData);
                }


                // const response = await callApi(API_ENDPOINTS.getCOList, {
                //     method: 'POST',
                //     headers: { 'Content-Type': 'application/json' },
                //     body: JSON.stringify(orderData),
                // });

                // const formattedData = response.map((row, index) => ({
                //     ...row,
                //     id: index + 1,
                // }));

                // setTableData(formattedData);
            } catch (error) {
                console.error('Error details:', error);
                showError('Unable to load order details', 'error');
            } finally {
                setLoading(false);
            }
        },
        []
    );

    return { tableData, loading, fetchOrders };
};
